import _ from 'lodash'
import { useMemo } from 'react'
import { CASINO_PROVIDERS_NAV_TYPE, DEFAULT_CASINO_TYPES } from '@/config/casino'
import { useGetLobbyCasinoTypesQuery } from '@/store/api/casinoApi'
import type { CasinoTypeId } from '@/types/casino'

export interface CasinoNavType {
	id: CasinoTypeId
	label: string
	icon: React.ComponentType<{ className?: string }> | string | null
	count?: number
}

export function useCasinoNavTypes(): CasinoNavType[] {
	const { data: typesResponse } = useGetLobbyCasinoTypesQuery()

	return useMemo(() => {
		const defaultTypeIds = _.map(DEFAULT_CASINO_TYPES, 'id')
		const dynamicTypes = _.filter(typesResponse?.data ?? [], (type) => !_.includes(defaultTypeIds, type.id) && type.id !== CASINO_PROVIDERS_NAV_TYPE.id)

		return [
			..._.map(DEFAULT_CASINO_TYPES, (type) => ({ ...type })),
			..._.map(dynamicTypes, (type) => ({
				id: type.id,
				label: _.capitalize(type.type_name),
				icon: type.icon,
				count: type.casinos_count,
			})),
			{ ...CASINO_PROVIDERS_NAV_TYPE },
		]
	}, [typesResponse?.data])
}
